export type ListResult<T> = {
    items: T[]
    /**@deprecated totalCount cannot always be returned due to dynamoDb restrictions*/
    totalCount?: number
    cursor?: string | number[]
}

export function getListResultPageParam(result: ListResult<any>) {
    return result.cursor;
}